export type EnvName = "local" | "dev" | "staging" | "prod";

export interface EnvConfig {
  name: EnvName;
  label: string;
  apiBaseUrl: string;
  keycloakIssuer: string;
  keycloakClientId: string;
  /** Creator Pro web app base URL for impersonation handoff. */
  creatorsAppUrl: string;
}

export const ENVS: Record<EnvName, EnvConfig> = {
  local: {
    name: "local",
    label: "Local",
    apiBaseUrl: "http://localhost:8777",
    keycloakIssuer: "http://localhost:7373/realms/saltpig",
    keycloakClientId: "saltpig-admin-web",
    creatorsAppUrl: "http://localhost:3001",
  },
  dev: {
    name: "dev",
    label: "Dev",
    apiBaseUrl: "https://api-dev.saltpig.app",
    keycloakIssuer: "https://auth.dev.saltpig.app/realms/saltpig",
    keycloakClientId: "saltpig-admin-web",
    creatorsAppUrl: "https://creators.dev.saltpig.app",
  },
  staging: {
    name: "staging",
    label: "Staging",
    apiBaseUrl: "https://api-staging.saltpig.app",
    keycloakIssuer: "https://auth.staging.saltpig.app/realms/saltpig",
    keycloakClientId: "saltpig-admin-web",
    creatorsAppUrl: "https://creators-staging.saltpig.app",
  },
  prod: {
    name: "prod",
    label: "Prod",
    apiBaseUrl: "https://api.saltpig.app",
    keycloakIssuer: "https://auth.saltpig.app/realms/saltpig",
    keycloakClientId: "saltpig-admin-web",
    creatorsAppUrl: "https://creators.saltpig.app",
  },
};

export const ENV_ORDER: EnvName[] = ["local", "dev", "staging", "prod"];
export const DEFAULT_ENV: EnvName = "dev";
export const ENV_STORAGE_KEY = "saltpig-admin:env";

export function isEnvName(value: unknown): value is EnvName {
  return typeof value === "string" && value in ENVS;
}
